var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back flex flex-align-center",on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('a-icon',{staticClass:"back-icon m10",attrs:{"type":"left-circle"}}),_c('span',[_vm._v("返回上一页")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }